@if (computedValue()) {
  <div *transloco="let t" class="range-slider-container">
    <div class="title">
      <div>{{ t(title()) }}</div>
      <div class="range-filter-values">
        {{monetaryRange() ? '$' : ''}}{{ computedValue().min }}-{{ computedValue().max ? computedValue().max : sliderParams().max }}{{ (computedValue().max == undefined && openMaxInterval()) ? '+' : '' }}
      </div>
    </div>
    <div class="range-slider">
      <mat-slider [min]="sliderParams().min" [max]="sliderParams().max" [step]="sliderParams().step">
        <input [value]="computedValue().min" (valueChange)="onMinChange($event)" matSliderStartThumb>
        <input [value]="computedValue().max ?? sliderParams().max" (valueChange)="onMaxChange($event)" matSliderEndThumb>
      </mat-slider>
    </div>
  </div>
}
